
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    export class ApprovalOutGrid extends Serenity.EntityGrid<ApprovalOutRow, any> {
        protected getColumnsKey() { return 'Sales.ApprovalOut'; }
        protected getDialogType() { return ApprovalOutDialog; }
        protected getIdProperty() { return ApprovalOutRow.idProperty; }
        protected getInsertPermission() { return ApprovalOutRow.insertPermission; }
        protected getLocalTextPrefix() { return ApprovalOutRow.localTextPrefix; }
        protected getService() { return ApprovalOutService.baseUrl; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container);  
            this.slickGrid.setOptions({ rowHeight: 30 });
        }

        protected addButtonClick() {
            
            let now = new Date();

            var voucherNo = FormatHelper.GetVoucherNo(32);

            var userDefinition = Q.Authorization.userDefinition;
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[32].AutoPosting;
            this.editItem(<ApprovalOutRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                TransDate: now.toDateString(),
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                EmployeeId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                VoucherTypeId: 32,
                AutoPosting: autoposting,
                UserId: userDefinition.UserId
                       
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        //protected getQuickFilters() {
        //    var filters = super.getQuickFilters();

        //    filters.push({
        //        type: Serenity.LookupEditor,
        //        options: {
        //            lookupKey: ApprovalOutRow.lookupKey
        //        },
        //        field: 'TransId',
        //        title: 'Contains Transaction in Details',
        //        handler: w => {
        //            (this.view.params as TransactionListRequest).TransId = Q.toId(w.value);
        //        },
        //        cssClass: 'hidden-xs'
        //    });

        //    return filters;
        //}
    }
}